import { render } from "./DataviewFiltersDropdownOptions.vue?vue&type=template&id=528e38de"
import script from "./DataviewFiltersDropdownOptions.vue?vue&type=script&lang=js"
export * from "./DataviewFiltersDropdownOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__